import React from 'react';
import UseAnimation from "react-useanimations";
import mail from 'react-useanimations/lib/mail';
import AOS from 'aos';
import "aos/dist/aos.css";
// import contact data
import { contact } from '../data';


const Contact = () => {
  AOS.init();
  return (
    <section className='section bg-primary' id='contact'>
      <div className='container mx-auto'>
        <div className='flex flex-col items-center text-center' data-aos='zoom-in'>
          <h2 className='section-title before:content-contact relative before:absolute before:opacity-40 before:-top-7 before:-left-40 before:hidden before:lg:block'>
            Get In Touch
          </h2>
          <p className='subtitle'>
            Submit the form below to get in touch with me!
          </p>
        </div>
        <div
          className='flex flex-col lg:gap-x-8 lg:flex-row'
        >
          <div
            className='flex flex-1 flex-col items-start space-y-8 mb-12 lg:mb-0 lg:pt-2'
          >
            {contact.map((item, index) => {
              const { icon, title, subtitle, description } = item;
              return (
                <div className='flex flex-col lg:flex-row gap-x-4' data-aos='zoom-in' key={index}>
                  <div className='text-accent rounded-sm w-14 h-14 flex items-start justify-center mt-2 mb-4 lg:mb-0 text-2xl'>
                    {icon}
                  </div>
                  <div>
                    <h4 className='font-tertiary text-xl mb-1'>{title}</h4>
                    <p className='font-tertiary mb-1 text-paragraph'>{subtitle}</p>
                    <p className='text-accent font-tertiary'>{description}</p>
                  </div>
                </div>
              );
            })}
          </div>
          <form
            action='https://getform.io/f/024ae9c2-d65c-42a8-85d8-62af0cbb9c33' method='POST'
            className='space-y-8 w-full max-w-[780px]'
          >
            <div className='flex gap-8'>
              <input className='input rounded-md' type='text' name='Full name' placeholder='Your Full name' required data-aos='flip-left' />
              <input className='input rounded-md' type='email' name='Email' placeholder='Your email' required data-aos='flip-right' />
            </div>
            <input className='input rounded-md' type='text' name='Subject' placeholder='Subject' required data-aos='flip-up' />
            <textarea
              className='textarea rounded-md' name='Message'
              placeholder='Your message' required data-aos='flip-down'
            ></textarea>
            <button type="submit" className='btn btn-lg w-full max-w-[780px] bg-accent hover:bg-secondary-hover rounded-md' data-aos='flip-up'>
            <UseAnimation animation={mail} size={35} />
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
